module.exports = __webpack_public_path__ + "static/fiddle-9b29c5396f57be58c0a820fd4b877abe.m4a";